// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_URL: 'https://api.agzgroupe.com/',
  // BASE_URL: 'http://localhost:8081/',
  AMADEUS_BASE_URL: 'https://api.agzgroupe.com/',
  BASE2_URL: 'http://75.119.130.11:8447/',
  AMADEUS_URL: 'https://api.agzgroupe.com/',
  UBA: {
      secretKey: '58b8fb251a18227c53f6cf05b577fe71be2424df',
      baseAPI: 'https://cm.instantbillspay.com/instantpay/payload/bill/payment',
      merchandId: 'CM0500029',
      encAlgo: 'SHA-512'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
